import { Provider, ProviderTaxonomy } from "@models/provider.model";
import { User, UserProviderDto } from "@models/user.model";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export interface CreateUpdateProviderData {
  firstName: string;
  lastName: string;
  npi: string;
  providerTaxonomyID: string;
  providerTaxonomyDescription: string;
  providerUserEmailAddress: string;
  phone: string;
  isActive: boolean;
  organizationID: string;
  effectiveDate?: string | null;
  expirationDate?: string | null;
}

export interface ProviderUploadResults {
  totalProcessed: number;
  created: number;
  updated: number;
  errors: number;
  errorDetails: Array<{
    row: number;
    message: string;
  }>;
  hasMoreErrors?: boolean;
  errorSummary?: ProviderUploadErrorSummary;
}

export interface ProviderUploadErrorSummary {
  totalErrors: number;
  missingDataCount: number;
  invalidEmailCount: number;
  duplicateNPICount: number;
  otherErrorsCount: number;
  displayedErrors: number;
}

export const ClinicianDetailsActions = createActionGroup({
  source: "ClinicianDetails",
  events: {
    "Clinician Details Component Loaded": emptyProps(),

    "Get Org Providers": emptyProps(),
    "Get Org Providers Success": props<{ response: Provider[] }>(),
    "Get Org Providers Failure": props<{ error: string }>(),

    "Get Provider Taxonomies": emptyProps(),
    "Get Provider Taxonomies Success": props<{ taxonomies: ProviderTaxonomy[] }>(),
    "Get Provider Taxonomies Failure": props<{ error: string }>(),

    "Create Provider": props<{ providerData: CreateUpdateProviderData }>(),
    "Create Provider Success": props<{ providerId: number }>(),
    "Create Provider Failure": props<{ error: string }>(),

    "Update Provider": props<{ providerId: any, providerData: CreateUpdateProviderData }>(),
    "Update Provider Success": props<{ providerId: number, updatedProvider: Provider }>(),
    "Update Provider Failure": props<{ error: string }>(),

    "Deactivate Provider": props<{ name: string, organizationProviderId: number }>(),
    "Confirm Deactivate Provider": props<{ organizationProviderId: number }>(),
    "Deactivate Provider Success": props<{ organizationProviderId: number }>(),
    "Deactivate Provider Failure": props<{ error: string }>(),

    "Create User from Provider Pressed": props<{ organizationProviderId: number, providerData: any }>(),
    "Create User from Provider": props<{ userData: UserProviderDto, organizationProviderId: number }>(),
    "Create User From Provider Success": props<{ userId: number, organizationProviderId: number }>(),
    "Create User From Provider Failure": props<{ error: string }>(),

    "Link User to Provider": props<{ userId: number, organizationProviderId: number }>(),
    "Link User to Provider Success": props<{ userId: number, organizationProviderId: number }>(),
    "Link User to Provider Failure": props<{ error: string }>(),

    "Unlink User from Provider": props<{ organizationProviderId: number }>(),
    "Unlink User from Provider Success": props<{ organizationProviderId: number }>(),
    "Unlink User from Provider Failure": props<{ error: string }>(),

    "Upload Providers": props<{ file: File; organizationId: string }>(),
    "Upload Providers Success": props<{ results: ProviderUploadResults }>(),
    "Upload Providers Failure": props<{ error: string }>(),
    "Upload Providers Progress": props<{ progress: number }>(),
    "Clear Provider Upload State": emptyProps(),
  },
});